import Logger from 'js-logger';
import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import $ from 'jquery';

import getUUID from './uuid';
import tvsmilesLogin from './tvsmilesAccountManagement';

// import constants and paths
import { sevenPassScript, defaultSevenPassOAuthAddress,
            defaultClientId, tvsAddressDefault, localStorageUUIDFieldName,
            registrationAddress, registrationAddressChallengeId } from './config.js';

let tvsAddress = tvsAddressDefault;
let sevenPassOAuthAddress = null;
let clientId = null;


class SevenPassLogin extends Component {
    constructor(props) {
        super(props);

        tvsAddress = this.props.target || tvsAddressDefault;

        this.state = {
            sevenPass: 'no user',
        };

        sevenPassOAuthAddress = this.props.conf7pass['7pass.api.baseUrl']
                                                || defaultSevenPassOAuthAddress;
        clientId = this.props.conf7pass['7pass.clientId'] || defaultClientId;

        console.log('In SevenPassLogin Challenge');

        if (this.props.code && this.props.code !== 'undefined') {
            this.getToken();
        } else {
            console.log('No code, redirect to 7pass registration');

            // Append the 7pass script
            const script = document.createElement('script');
            script.src = sevenPassScript;
            document.body.appendChild(script);

            // when downloaded, set up 7pass and redirect to it
            script.addEventListener('load', () => {
                this.sso = new window.PSDA.SSO({
                    client_id: clientId,
                    authorization_uri: `${sevenPassOAuthAddress}/connect/v1.0/authorize`,
                    scope: 'openid profile email phone address',
                    mode: 'redirect',
                    response_type: 'code',
                    redirect_uri: `${window.location.origin}/login/cb`,
                    query: {
                        prompt: 'register',
                        utm_term: 'kwizzad',
                    },
                    // Apparently environment is not needed anymore
                    // environment: 'qa',
                });
                
                // redirection
                this.sevenTrigger();
            });
        }
    }

    componentWillMount() { }

    componentDidMount() { }

    getToken() {
        getUUID(tvsAddress).done(uuid => {
            // Build the OAuth request
            const oAuthTokenSettings = {
                url: `${tvsAddress}/api/v4/user/7pass/token`,
                method: 'POST',
                headers: {
                    'content-type': 'application/json; charset=utf-8',
                },
                data: `{
                    clientId: ${clientId},
                    code: '${this.props.code}',
                    redirectUri: '${window.location.origin}/login/cb'
                }`,
            };

            $.ajax(oAuthTokenSettings)
                .done((oAuthTokenResponse) => {
                    // console.log(oAuthTokenResponse);
                    // Link the created tvsmiles device/user to the current kwizzad session
                    const putWait = this.tvsmilesPut();
                    // console.log('putWait', putWait);

                    putWait.then((result) => {
                        console.log('RESULT', result, putWait);

                        // Trying to login w/ tvsmiles
                        tvsmilesLogin(this,
                                      clientId,
                                      tvsAddress,
                                      uuid,
                                      oAuthTokenResponse.refreshToken.token,
                                      () => {
                                          this.goNext();
                                      });
                    });
                })
                .fail((error) => {
                    console.error('Something went wrong while getting the code');
                    console.error(error);
                });
        }).fail(error => {
            console.log('Error while getting UUID:', error);
        });
    }


    sevenTrigger() {
        Logger.debug('7pass Triggered');

        // set localStorage in order to restore the campaign
        localStorage.setItem(registrationAddress, window.location.href);
        localStorage.setItem(registrationAddressChallengeId, this.props.challenge.id);

        // console.log(this.sso);
        this.sso.redirect(null, () => {
            console.log('SSO FINISHED');
        });
    }

    goNext() {
        console.log('deleting localStorage');
        localStorage.removeItem(registrationAddressChallengeId);
        localStorage.removeItem(registrationAddress);
        localStorage.removeItem(localStorageUUIDFieldName);
        this.props.next();
    }

    tvsmilesPut() {
        return new Promise((resolve, reject) => {
            const settings = {
                // eslint-disable-next-line max-len
                url: `${tvsAddress}/api/trackingtoken/${this.props.trackingtoken}?deviceUdid=${localStorage.getItem(localStorageUUIDFieldName)}`,
                method: 'PUT',
            };
            $.ajax(settings)
                .done(() => {
                    resolve('done');
                })
                .fail(() => {
                    reject(new Error('Could not put'));
                });
        });
    }


    render() {
        return (<div id="loadingPage" className={this.props.className}>
            {/* <img id="spinner" src="/iframeSupport/assets/ring.gif" />  */}
        </div>);
    }
}

// Validate all props that are used inside the component to warn early if they're not supplied
// correctly
SevenPassLogin.propTypes = {
    code: PropTypes.number,
    target: PropTypes.string,
    trackingtoken: PropTypes.string.isRequired,
    conf7pass: PropTypes.shape({
        '7pass.api.baseUrl': PropTypes.string,
        '7pass.clientId': PropTypes.string,
    }),
    next: PropTypes.func.isRequired,
};


const StyledSevenPassLogin = styled(SevenPassLogin)`
  background-color: rgb(50, 49, 54);
  height: 100%;
  width: 100%;
  margin: 0;

  #spinner {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;

export default StyledSevenPassLogin;



// WEBPACK FOOTER //
// ./src/campaign/challenges/sevenPassLogin/seven-pass-login.jsx